import React from 'react';

import { Stack, Box } from '@atlaskit/primitives/compiled';

import type { Snippet } from '../snippetTypes.ts';

import { SnippetPanelItem } from './SnippetPanelItem.tsx';
import { useSnippetPopupPreview } from './SnippetPopupPreviewContext.tsx';

type SnippetPanelListProps = {
	snippets: Snippet[];
	contentId: string;
	spaceId: string;
	spaceKey: string;
};

export const SnippetPanelList = ({
	snippets,
	contentId,
	spaceId,
	spaceKey,
}: SnippetPanelListProps) => {
	const { hidePreview } = useSnippetPopupPreview();

	return (
		<Box onMouseLeave={hidePreview}>
			<Stack>
				{snippets?.map((snippet) => (
					<SnippetPanelItem
						key={snippet.snippetId}
						snippet={snippet}
						contentId={contentId}
						spaceId={spaceId}
						spaceKey={spaceKey}
					/>
				))}
			</Stack>
		</Box>
	);
};
